<template>
    <div id="team" class="container employees">
        <h1 class="page-header contact-title"
        v-text="lang('Il Team')"></h1>

        <div class="columns is-multiline">
            <employee-element v-for="employee in employees"
                              :key="employee.id" :employee="employee"
                              @click="open"></employee-element>
        </div>

        <employee-modal v-if="employee" @close="close" :active="modalOpen" :employee="employee"></employee-modal>

    </div>
</template>
<script>
    export default {
        props: {
            employees: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                modalOpen: false,
                employee: null
            }
        },
        methods: {
            open( employee ) {
                this.employee = employee;
                this.modalOpen = true
            },
            close() {
                this.modalOpen = false
            }
        }
    }
</script>